/**
* Components are lazy-loaded - See "Grouping Components in the Same Chunk"
* http://router.vuejs.org/en/advanced/lazy-loading.html
*/
/* eslint-disable global-require */
const viewasTeamportal = r => require.ensure([], () => r(require('./components/viewas_teamportal')), 'teamportalpages');
const customizeTeamportal = r => require.ensure([], () => r(require('./components/customize_teamportal')), 'teamportalpages');
export default [ 
    {
        name: 'viewasTeamportal',
        path: '/teamportal/view-as',
        component: viewasTeamportal,
    },
    {
        name: 'customizeTeamportal',
        path: '/teamportal/customise',
        component: customizeTeamportal,
    },
]



// WEBPACK FOOTER //
// ./src/app/teamportalpages/routes.js